import { css } from '@emotion/core'

export default ({ theme: { colors, typography } }) => css`
  list-style: none;
  position: relative;
  text-transform: uppercase;
  padding: 5px;
  font-family: ${typography.headings.fontFamily};
  letter-spacing: ${typography.headings.letterSpacing};
  font-size: 1rem;
  color: ${colors.text3};
  background-color: ${colors.bodyBackground};

  &:before {
    content: 'YOU ARE HERE :';
    padding-right: 0.5rem;
    color: ${colors.body};
  }

  li {
    padding: 0 0.2em 0 0.2em;
    display: inline-block;
    position: relative;
    z-index: 3;

    &:first-of-type {
      &:before {
        height: 20px;
        width: 100%;
        margin: 0 0.3em 0 0;
        color: ${colors.text4};
        content: '/';
      }
    }
  }

  a {
    color: ${colors.text3};
    text-decoration: none;

    &:visited {
      color: ${colors.text3};
    }

    &:hover {
      color: ${colors.body};
      text-decoration: none;
    }

    &:after {
      height: 20px;
      width: 100%;
      margin: 0 0 0 0.3em;
      color: ${colors.text4};
      content: '/';
    }
  }
`
